@let memberDataValue = memberData();
@let canManageTellentValue = canManageTellent();
@let memberNotInvitedValue = memberNotInvited();

<rt-dialog-body variant="white" [class.no-footer]="memberNotInvitedValue">
  <div class="container">
    <div class="heading">
      <rt-heading variant="large heading">
        {{ 'tlc.members.edit_member.permission_access_tab.heading.title_v2' | translate }}
      </rt-heading>
      <span margin-bottom-small-x
        >{{ 'tlc.members.edit_member.permission_access_tab.heading.description_v2' | translate }}
      </span>
    </div>

    @if (memberNotInvitedValue) {
      <tlc-invite-member-without-access-box (inviteClick)="sendInvitation()" />

      @if (memberHasNoKiwiSeat()) {
        <rt-infobox
          type="information"
          iconName="info-outline"
          [isDismissible]="false"
          margin-top-small
        >
          <div class="infobox-content">
            <span class="heading">{{
              'tlc.members.edit_member.permission_access_tab.listed_only_infobox.title' | translate
            }}</span>
            <span>{{
              'tlc.members.edit_member.permission_access_tab.listed_only_infobox.subtitle'
                | translate
            }}</span>
          </div>
        </rt-infobox>
      }
    } @else {
      <tlc-edit-member-permissions-box
        [abilities]="memberDataValue?.abilities || []"
        [canManageTellent]="canManageTellentValue"
        (actionClicked)="onStatusActionClicked()"
        margin-bottom-large
      />
      <tlc-access-roles-table [recruiteeFormGroup]="seats.recruitee" [kiwiFormGroup]="seats.kiwi" />
    }
  </div>
</rt-dialog-body>

@if (!memberNotInvitedValue) {
  <rt-dialog-footer variant="white">
    <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
    <rt-button [loading]="pending()" (click)="submit()" variant="primary"
      >{{ 'tlc.common.save' | translate }}
    </rt-button>
  </rt-dialog-footer>
}
